import React from "react"
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import {colors} from '../../../../style/constants';
import PostCard from '../../card';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    marginTop: -90,
    '& > div > div > div': {
      paddingTop: 30,
      borderTop: colors.DARK_GREY + ' 1px solid',
    }
  },
  card: {
    '&:first-child': {
      paddingRight: 15
    },
    '&:last-child': {
      paddingLeft: 15
    }
  }
}));

const Latests = (props) => {
  
  const renderLatests = () => {
    return props.posts.map((post, index) => {
      return (
        <Grid className={classes.card} key={index} item xs={6}>
          <PostCard lang={props.lang} post={post.node} />
        </Grid>
      );
    });
  }

  const classes = useStyles();
  return (
    <section className={classes.wrapper}>
      <Container>
        <Grid container justifyContent='center'>
          <Grid item xs={12} sm={10} md={8}>
            <h2>{props.lang === 'en-CA' ? 'Latests posts' : 'Articles récents'}</h2>
            <Grid className={classes.posts} container>
              {renderLatests()}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </section>
  )
}

export default Latests
